<script lang="ts">
  import { notificationIds } from '$stores';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  export let notificationId: number;
  let inviewRef: HTMLElement | undefined;
  onMount(() => {
    if (!inviewRef) {
      return;
    }
    const loadingObserver = new IntersectionObserver((entries) => {
      const element = entries[0];
      if (element.isIntersecting) {
        notificationIds.set([...get(notificationIds), notificationId]);
      }
    });

    loadingObserver.observe(inviewRef);
  });
</script>

<div bind:this={inviewRef} class="absolute bottom-0 h-px w-full" />
